import React, { useState, useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { isEmpty } from 'lodash';
import {
  validateBankName,
  validateAccountNo,
  validateAccountHolderName,
  validateCinNumber,
  validateIbanNumber,
  validateSwiftCode,
  validateBranchName,
} from '../../utils/generalUtils';

import { generalUtils } from '../../utils';
import { Button, LoaderSpinner } from '../../components';
import { artistActions } from '../../actions';

import '../NewCustomer/NewCustomer.scss';
import './ArtistDetailsProfile.scss';

const validateFormFields = (formFields) => {
  const errors = {
    bank_name: validateBankName(formFields.bank_name),
    acc_no: validateAccountNo(formFields.acc_no),
    acc_holder_name: validateAccountHolderName(formFields.acc_holder_name),
    cin_no: validateCinNumber(formFields.cin_no),
    iban: validateIbanNumber(formFields.iban),
    swift_code: validateSwiftCode(formFields.swift_code),
    branch_code: validateBranchName(formFields.branch_code),

    // bank_name: isEmpty(formFields.bank_name) ? 'Bank Name is required' : '',
    // acc_no: generalUtils.validateNumber(formFields.acc_no, 'Account Number'),
    // acc_holder_name: isEmpty(formFields.acc_holder_name) ? 'Account Holder Name is required' : '',
    // cin_no: generalUtils.validateNumber(formFields.cin_no, 'CIN Number'),
    // iban: generalUtils.validateNumber(formFields.iban, 'IBAN Number'),
    // swift_code: generalUtils.validateNumber(formFields.swift_code, 'Swift'),
    // branch_code: isEmpty(formFields.branch_code) ? 'Branch is required' : '',
  };

  return errors;
};

function ArtistDetailsProfile(props) {
  const { artist, setArtist } = props;
  const [formFields, setFormFields] = useState({});
  const [errors, setErrors] = useState();
  console.log(formFields, 'maysuddfjfifii');
  const [isLoading, setIsLoading] = useState(false);
  const [isChanged, setIsChanged] = useState(false);

  const useStyles = makeStyles({
    cancelButton: {
      borderRadius: 32,
      background: '#40189D',
      boxShadow: 'none',
      width: 160,
      padding: '12px 0px',
      cursor: 'pointer',
      opacity: isChanged ? 1 : 0.5,
    },
  });

  const classes = useStyles();

  const handleInputChange = (event) => {
    let id = event.target.id;
    let value = event.target.value;
    setFormFields({ ...formFields, [id]: value });
    setErrors({ ...errors, [id]: '' });
  };
  console.log('eriiirri', errors);
  const hadleSubmit = async () => {
    const errors = validateFormFields(formFields);
    if (!generalUtils.isEmptyObject(errors)) {
      return setErrors(errors);
    }
    setIsLoading(true);

    const isSuccess = await artistActions.updateArtist(artist.id, {
      bank_name: formFields.bank_name,
      acc_no: formFields.acc_no,
      acc_holder_name: formFields.acc_holder_name,
      cin_no: formFields.cin_no,
      iban: formFields.iban,
      swift_code: formFields.swift_code,
      branch_code: formFields.branch_code,
    });
    setIsLoading(false);
    setIsChanged(false);

    if (isSuccess) {
      setArtist({ ...artist, ...formFields });
    }
  };

  useEffect(() => {
    setFormFields(artist);
  }, [artist]);

  useEffect(() => {
    // check if any values from formfields is defffereent from artist
    const isChanged = Object.keys(formFields).some((key) => formFields[key] !== artist[key]);
    setIsChanged(isChanged);
  }, [formFields]);

  return (
    <div className="new_customer_row">
      <h5>Bank details</h5>
      <div className="field_row">
        <div className="field_col">
          <label>Bank Name</label>

          <input type="text" value={formFields.bank_name} onChange={handleInputChange} id="bank_name" />
          <span className="input-error-messages">{errors && errors['bank_name']}</span>
        </div>

        <div className="field_col">
          <label>Account Number</label>
          <input type="text" value={formFields.acc_no} onChange={handleInputChange} id="acc_no" />
          <span className="input-error-messages">{errors && errors['acc_no']}</span>
        </div>

        <div className="field_col">
          <label>Account Holder Name</label>
          <input type="text" value={formFields.acc_holder_name} onChange={handleInputChange} id="acc_holder_name" />
          <span className="input-error-messages">{errors && errors['acc_holder_name']}</span>
        </div>

        <div className="field_col">
          <label>CIN Number</label>
          <input type="text" value={formFields.cin_no} onChange={handleInputChange} id="cin_no" />
          <span className="input-error-messages">{errors && errors['cin_no']}</span>
        </div>

        <div className="field_col">
          <label>IBAN Number</label>
          <input type="text" value={formFields.iban} onChange={handleInputChange} id="iban" />
          <span className="input-error-messages">{errors && errors['iban']}</span>
        </div>

        <div className="field_col">
          <label>Swift</label>
          <input type="text" value={formFields.swift_code} onChange={handleInputChange} id="swift_code" />
          <span className="input-error-messages">{errors && errors['swift_code']}</span>
        </div>

        <div className="field_col">
          <label>Branch</label>
          <input type="text" value={formFields.branch_code} onChange={handleInputChange} id="branch_code" />
          <span className="input-error-messages">{errors && errors['branch_code']}</span>
        </div>
      </div>

      <Button isLoading={isLoading} disabled={!isChanged} onClick={hadleSubmit} variant="contained" className={classes.cancelButton}>
        <p className="btn_Cancel">Save Changes</p>
      </Button>
    </div>
  );
}

export default ArtistDetailsProfile;
